/* istanbul ignore file */
import { useEffect, useState } from 'react';

import { MARKETPLACE_ID } from '@amzn/sss-website-theme';

import { useAcpsCreditsClient } from 'src/clients/acps';

export interface UserPreferencesContext {
  userPreferredMarketplaceId: string | undefined;
  isLoading: boolean;
}

/**
 * Fetches the user's preferred marketplace ID from the ACPS GetUserPreferences API.
 * Returns the marketplace ID (e.g., ATVPDKIKX0DER for NA, A1F83G8C2ARO7P for EU)
 * or defaults to NA if not set.
 */
export const useGetUserPreferences = (): UserPreferencesContext => {
  const [userPreferredMarketplaceId, setUserPreferredMarketplaceId] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const acpsClient = useAcpsCreditsClient();

  useEffect(() => {
    const fetchPreferences = async () => {
      try {
        const response = await acpsClient.getUserPreferences();
        setUserPreferredMarketplaceId(response.userPreferredMarketplaceId ?? MARKETPLACE_ID.NA);
      } catch {
        setUserPreferredMarketplaceId(MARKETPLACE_ID.NA);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPreferences();
  }, [acpsClient]);

  return { userPreferredMarketplaceId, isLoading };
};
